import { useState, useEffect } from "react";

/**
 * Hook that monitors the DOM for modal dialogs
 * @returns {boolean} True if a modal dialog is currently visible
 */
export const useModalAlertObserver = (): boolean => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  useEffect(() => {
    const checkForModal = (): boolean =>
      document.querySelector(".MuiDialog-root") !== null;

    // Do an initial check
    setIsModalVisible(checkForModal());

    // Set up MutationObserver to watch for changes in the document body
    const observer = new MutationObserver(() => {
      const modalVisible = checkForModal();
      // Only update state if the modal visibility has changed
      if (modalVisible !== isModalVisible) {
        setIsModalVisible(modalVisible);
      }
    });

    // Observe the entire subtree and watch for both element and attribute changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    // Clean up on unmount
    return () => {
      observer.disconnect();
    };
  }, [isModalVisible]); // Added dependency to prevent stale closure issues

  return isModalVisible;
};
